import Vue from "vue";
import Component from "vue-class-component";

import { IProductsCategoryTypes } from "@/entity/warehouse/Products/Category/Category.types";
import { ProductsCategoriesStore } from "@/store/modules/Warehouse/ProductsCategories";
import { WarehouseSupport } from "@/store/modules/Warehouse/Support/current";

@Component
export class ProductsCategoriesMix extends Vue {
    dataCategories = ProductsCategoriesStore.dataCategories;
    Wcd = WarehouseSupport;

    get productsCategoriesData(): IProductsCategoryTypes[] | null {
        return ProductsCategoriesStore.productsCategories;
    }
    async setDefaultCategoryWcd(): Promise<void> {
        this.dataCategories.forEach((data, index: number) => {
            if (index === 0) {
                this.Wcd.setDefaultCategory(data.index);
            }
        });
    }
    async getCategories(salon_id?: number): Promise<void> {
        const source_id = !salon_id ? this.$store.state["salon_id"] : salon_id;
        await ProductsCategoriesStore.fetchAll({
            // filter: { parent_id: 0, salon_id: source_id },
            filter: {salon_id: source_id },
        });
        await ProductsCategoriesStore.fetchCategories();
    }

    /* get productsCategory():IProductsCategoryTitem | null {
       return ProductsCategories.productsCategories
   }*/
}
